import { useWindowSize } from '@utils/hooks';
import styles from './License.module.scss';

import { useEffect } from 'react';

declare global {
  interface Window {
    anj_fb512a7c_9745_4a9b_a00a_8b9720749f1b?: {
      init: () => void;
    };
  }
}

export const License = () => {
  const { width: screenWidth } = useWindowSize();

  useEffect(() => {
    if (window.anj_fb512a7c_9745_4a9b_a00a_8b9720749f1b) {
      window.anj_fb512a7c_9745_4a9b_a00a_8b9720749f1b.init();
    }
  }, []);

  return (
    <div
      id="anj-fb512a7c-9745-4a9b-a00a-8b9720749f1b"
      data-anj-seal-id="fb512a7c-9745-4a9b-a00a-8b9720749f1b"
      data-anj-image-size="52"
      data-anj-image-type="basic-small"
      className={screenWidth > 1024 ? styles.licenseIcon : styles.licenseIconMobile}
    />
  );
};
